import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const VehicleAllocationDetailsDesign = () => {
  const navigate = useNavigate();

  const [Customername, setCustomername] = useState("");
  const [Address, setAddress] = useState("");
  const [Date, setDate] = useState("");
  const [Bookingno, setBookingno] = useState("");
  const [Contactno, setContactno] = useState("");
  const [Saleconsultant, setSaleconsultant] = useState("");
  const [Teamleader, setTeamleader] = useState("");
  const [Manager, setManager] = useState("");
  const [Model, setModel] = useState("");
  const [Variant, setVariant] = useState("");
  const [Color, setColor] = useState("");
  const [Fsccode, setFsccode] = useState("");
  const [Location, setLocation] = useState("");
  const [Manufactureyear, setManufactureyear] = useState("");
  const [Pdi, setPdi] = useState("");
  const [DeliveryDate, setDeliveryDate] = useState("");
  const [Status, setStatus] = useState("");
  const [gridRows, setGridRows] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [va12, setVa12] = useState(""); // this is txt_va_12 equivalent
  const [modelOptions, setModelOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [vinOptions, setVinOptions] = useState([]);
  const [vinDetails, setVinDetails] = useState(null);
  const [Vinno, setVinno] = useState(null);
  const isCustomerSelected = !!Customername;
  const isVinEnabled = isCustomerSelected;
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const locationState = useLocation();
  const editUnqId = locationState.state?.unqid || null;

  const customStyles = {
    control: (base) => ({ ...base, minHeight: "40px" }),
  };
  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);
  const handleExit = () => navigate("/VehicleAllocationGrid");

  useEffect(() => {
    if (!editUnqId) {
      resetForm();
    }
  }, [editUnqId]);
  const resetForm = () => {
    setCustomername("");
    setAddress("");
    setDate("");
    setBookingno("");
    setContactno("");

    setSaleconsultant(null);
    setTeamleader(null);
    setManager(null);

    setModel(null);
    setVariant(null);
    setColor(null);

    setVinno(null);
    setFsccode("");
    setLocation(null);

    setManufactureyear("");
    setPdi("");
    setDeliveryDate("");
    setStatus("");

    setGridRows([]);
    setVa12("");
  };

  useEffect(() => {
    loadCustomers();
  }, [va12]);

  const loadCustomers = async () => {
    try {
      const response = await apiFetch(
        "/api/vehicle/customerlist",
        { method: "POST", body: JSON.stringify({ va_12: va12, va_11: storedUserInfo?.branchUnq || storedUserInfo?.branch || "" }) },
      );
      const data = await response.json();
      const arr = Array.isArray(data) ? data : [];
      const options = arr.map((row) => ({
        value: row.m1_2 || row.data || row.value,
        label: row.m1_7 || row.label || row.value,
      }));
      console.log("Customer options:", options, "Raw data:", data);
      setCustomerOptions(options);
      if (editUnqId && options.length > 0) setCustomername(options[0].value);
    } catch (err) {
      console.error("Customer load error:", err);
    }
  };
  useEffect(() => {
    apiFetch("/api/vehicle/model")
      .then((res) => res.json())
      .then((data) => setModelOptions(data.map((r) => ({ value: r.sp_202, label: r.sp_207 }))));
  }, []);

  useEffect(() => {
    apiFetch("/api/vehicle/variant")
      .then((res) => res.json())
      .then((data) => setVariantOptions(data.map((r) => ({ value: r.sp_20_2, label: r.sp_20_3 }))));
  }, []);

  useEffect(() => {
    apiFetch("/api/vehicle/colour")
      .then((res) => res.json())
      .then((data) => setColorOptions(data.map((r) => ({ value: r.sp_142, label: r.sp_147 }))));
  }, []);

  useEffect(() => {
    apiFetch("/api/vehicle/staff")
      .then((res) => res.json())
      .then((data) => setStaffOptions(data.map((r) => ({ value: r.mcm_14, label: r.mcm_15 }))));
  }, []);

  useEffect(() => {
    apiFetch("/api/vehicle/location")
      .then((res) => res.json())
      .then((data) => setLocationOptions(data.map((r) => ({ value: r.sp_152, label: r.sp_157 }))));
  }, []);
  useEffect(() => {
    if (!Customername || !staffOptions.length) return;

    handleCustomerChange(Customername);
  }, [staffOptions]);

  const handleCustomerChange = async (customerId) => {
    try {
      const response = await apiFetch(
        "/api/vehicle/customer-change",
        { method: "POST", body: JSON.stringify({ customer_id: customerId }) },
      );
      const res = await response.json();
      const d = Array.isArray(res) ? res[0] : res;
      if (!d) return;

      setBookingno(d.repno || "");
      setAddress(d.add1 || "");
      setContactno(d.phone || "");

      if (d.bo_32) {
        const [dd, mm, yy] = d.bo_32.split("/");
        setDate(`${yy}-${mm}-${dd}`);
      }

      // STAFF
      setSaleconsultant(
        staffOptions.find(
          (o) => String(o.value).trim() === String(d.sale_id).trim(),
        ) || null,
      );

      setTeamleader(
        staffOptions.find((o) => o.label.trim() === String(d.team_id).trim()) ||
          null,
      );

      setManager(
        staffOptions.find(
          (o) => o.label.trim() === String(d.manager_id).trim(),
        ) || null,
      );

      // VEHICLE
      const modelObj =
        modelOptions.find((o) => String(o.value) === String(d.model_id)) ||
        null;

      const variantObj =
        variantOptions.find((o) => String(o.value) === String(d.variant_id)) ||
        null;

      const colorObj =
        colorOptions.find((o) => String(o.value) === String(d.color_id)) ||
        null;

      setModel(modelObj);
      setVariant(variantObj);
      setColor(colorObj);
    } catch (err) {
      console.error("Customer change load error:", err);
    }
  };

  useEffect(() => {
    if (!Model || !Variant || !Color) {
      setVinOptions([]);
      return;
    }

    apiFetch("/api/vehicle/vin-list", {
      method: "POST",
      body: JSON.stringify({
        model_id: Model.value,
        variant_id: Variant.value,
        color_id: Color.value,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!Array.isArray(data)) { setVinOptions([]); return; }
        setVinOptions(data.map((r) => ({
          value: r.data,
          label: r.data,
          fsccode: r.fsccode,
          year: r.mfcyr,
          location: r.location,
        })));
      })
      .catch(() => setVinOptions([]));
  }, [Model, Variant, Color]);
  useEffect(() => {
    if (!Model || !Variant || !Color) return;

    loadVinGrid(Model.value, Variant.value, Color.value);
  }, [Model, Variant, Color]);

  const loadVinGrid = async (modelId, variantId, colorId) => {
    try {
      const response = await apiFetch(
        "/api/vehicle/all-vin-details",
        { method: "POST", body: JSON.stringify({ model_id: modelId, variant_id: variantId, color_id: colorId }) },
      );
      const data = await response.json();
      setGridRows(
        Array.isArray(data)
          ? data.map((r) => ({
              model: r.sp_45, variant: r.sp_46, color: r.sp_47,
              year: r.sp_49, fsc: r.sp_38, vin: r.sp_55,
              pdi: r.sp_50, location: r.sp_56, ageing: r.ageing,
            }))
          : [],
      );
    } catch (err) {
      console.error("Grid load error:", err);
      setGridRows([]);
    }
  };
  const handleSave = async () => {
    if (!Customername || !Vinno) {
      alert("Please select Customer and VIN");
      return;
    }

    const payload = {
      va_13: storedUserInfo?.userid || "",
      va_14: ipAddress || "",
      va_15: serverIp || "",

      va_17: Date || "", // ✅ ENTRY DATE
      va_24: Address || "", // ✅ ADDRESS
      va_25: Contactno || "", // ✅ CONTACT NO

      va_18: Bookingno,
      va_20: Saleconsultant?.value || "",
      va_21: Teamleader?.value || "",
      va_22: Manager?.value || "",
      va_23: Customername,
      va_26: Model?.value || "",
      va_27: Variant?.value || "",
      va_28: Color?.value || "",
      va_29: Vinno.value,
      va_30: Location?.value || "",
    };

    console.log("SAVE PAYLOAD:", payload);

    try {
      const response = await apiFetch(
        "/api/vehicle/save-allocation",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      if (data?.err === "0") {
        alert("Vehicle Allocated Successfully ✅");
        loadVinGrid(Model.value, Variant.value, Color.value);
        setVinno(null);
      } else {
        alert(data?.msg || "Save failed");
      }
      navigate("/VehicleAllocationGrid");
    } catch (err) {
      console.error("Save failed:", err);
      alert("Server error");
    }
  };
  useEffect(() => {
    if (
      editUnqId &&
      staffOptions.length &&
      modelOptions.length &&
      variantOptions.length &&
      colorOptions.length &&
      locationOptions.length
    ) {
      loadEditData();
    }
  }, [
    editUnqId,
    staffOptions,
    modelOptions,
    variantOptions,
    colorOptions,
    locationOptions,
  ]);

  const loadEditData = async () => {
    try {
      const response = await apiFetch(
        "/api/vehicle/allocation-edit",
        { method: "POST", body: JSON.stringify({ unqid: editUnqId }) },
      );
      const data = await response.json();
      if (!Array.isArray(data) || !data.length) return;
      const d = data[0];

      setVa12(d.unq || "");

      setDate(d.date || "");
      setBookingno(d.receiptno || "");
      setAddress(d.address || "");
      setContactno(d.contactno || "");

      setCustomername(d.custunq);

      // STAFF
      setSaleconsultant(
        staffOptions.find((o) => String(o.value) === String(d.scunq)) || null,
      );

      setTeamleader(
        staffOptions.find((o) => String(o.value) === String(d.tlunq)) || null,
      );

      setManager(
        staffOptions.find((o) => String(o.value) === String(d.managerunq)) ||
          null,
      );

      // VEHICLE
      const modelObj =
        modelOptions.find((o) => String(o.value) === String(d.modelunq)) ||
        null;

      const variantObj =
        variantOptions.find((o) => String(o.value) === String(d.varunq)) ||
        null;

      const colorObj =
        colorOptions.find((o) => String(o.value) === String(d.colorunq)) ||
        null;

      setModel(modelObj);
      setVariant(variantObj);
      setColor(colorObj);

      // VIN
      const vinObj = {
        value: d.vin,
        label: d.vin,
        fsccode: d.fsccode,
        year: d.mfcyr,
        location: d.location,
      };

      setVinno(vinObj);
      setFsccode(d.fsccode || "");
      setManufactureyear(d.mfcyr || "");

      setLocation(
        locationOptions.find(
          (o) => String(o.value) === String(d.locationunq),
        ) || null,
      );
    } catch (err) {
      console.error("Edit load error:", err);
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Vehicle Allocation</div>

          {/* FORM ROW 1 */}
          <div className="form-row">
            <div className="form-column">
              <label>Customer Name</label>
              <Select
                placeholder="Select Customer"
                options={customerOptions}
                value={
                  customerOptions.find((o) => o.value === Customername) || null
                }
                onChange={(e) => {
                  const selectedId = e?.value;
                  setCustomername(selectedId);
                  handleCustomerChange(selectedId);
                }}
              />
            </div>
            <div className="form-column">
              <label>Address</label>
              <input
                value={Address}
                disabled={true}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>

          {/* FORM ROW 2 */}
          <div className="form-row">
            <div className="form-column">
              <label>Date</label>
              <input
                type="date"
                value={Date}
                disabled={true}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Booking No</label>
              <input
                value={Bookingno}
                disabled={true}
                onChange={(e) => setBookingno(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Contact No</label>
              <input
                value={Contactno}
                disabled={true}
                onChange={(e) => setContactno(e.target.value)}
              />
            </div>
          </div>

          {/* FORM ROW 3 */}
          <div className="form-row">
            <div className="form-column">
              <label>Sale Consultant</label>
              <Select
                options={staffOptions}
                isDisabled={true}
                value={Saleconsultant}
                placeholder="Select Sale Consultant"
                classNamePrefix="rs"
                styles={customStyles}
                onChange={(e) => setSaleconsultant(e)}
              />
            </div>
            <div className="form-column">
              <label>Team Leader</label>
              <Select
                options={staffOptions}
                isDisabled={true}
                value={Teamleader}
                placeholder="Select Team Leader"
                classNamePrefix="rs"
                styles={customStyles}
                onChange={(e) => setTeamleader(e)}
              />
            </div>
            <div className="form-column">
              <label>Manager</label>
              <Select
                options={staffOptions}
                isDisabled={true}
                value={Manager}
                placeholder="Select Manager"
                classNamePrefix="rs"
                styles={customStyles}
                onChange={(e) => setManager(e)}
              />
            </div>
          </div>

          {/* FORM ROW 4 */}
          <div className="form-row">
            <div className="form-column">
              <label>Model</label>
              <Select
                options={modelOptions}
                isDisabled={true}
                placeholder="Select Model"
                classNamePrefix="rs"
                styles={customStyles}
                value={Model}
                onChange={setModel}
              />
            </div>
            <div className="form-column">
              <label>Variant</label>
              <Select
                options={variantOptions}
                isDisabled={true}
                placeholder="Select Variant"
                classNamePrefix="rs"
                styles={customStyles}
                value={Variant}
                onChange={setVariant}
              />
            </div>
            <div className="form-column">
              <label>Color</label>
              <Select
                options={colorOptions}
                isDisabled={true}
                placeholder="Select Color"
                classNamePrefix="rs"
                styles={customStyles}
                value={Color}
                onChange={setColor}
              />
            </div>
          </div>

          {/* FORM ROW 5 */}
          <div className="form-row">
            <div className="form-column">
              <label>VIN No</label>
              <Select
                options={vinOptions}
                value={Vinno}
                isDisabled={!isVinEnabled}
                placeholder="Select VIN No"
                onChange={(v) => {
                  setVinno(v);

                  setFsccode(v.fsccode || "");
                  setManufactureyear(v.year || "");
                  setLocation(
                    locationOptions.find(
                      (o) => String(o.value) === String(v.location),
                    ) || null,
                  );
                }}
              />
            </div>
            <div className="form-column">
              <label>FSC Code</label>
              <input
                value={Fsccode}
                disabled={true}
                onChange={(e) => setFsccode(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Location</label>
              <Select
                options={locationOptions}
                value={Location}
                isDisabled={true}
                placeholder="Select Location"
                classNamePrefix="rs"
                styles={customStyles}
              />
            </div>
          </div>

          {/* FORM ROW 6 */}
          <div className="form-row">
            <div className="form-column">
              <label>Manufacturing Year</label>
              <input
                value={Manufactureyear}
                disabled={true}
                onChange={(e) => setManufactureyear(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>PDI</label>
              <input
                disabled={true}
                value={Pdi}
                onChange={(e) => setPdi(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Delivery Date</label>
              <input
                type="date"
                disabled={true}
                value={DeliveryDate}
                onChange={(e) => setDeliveryDate(e.target.value)}
              />
            </div>
          </div>

          {/* STATUS */}
          <div className="form-row">
            <div className="form-column">
              <label>Status</label>
              <input
                disabled={true}
                value={Status}
                onChange={(e) => setStatus(e.target.value)}
              />
            </div>
          </div>

          {/* GRID */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>S.N.</th>
                  <th>Model</th>
                  <th>Variant</th>
                  <th>Color</th>
                  <th>Year</th>
                  <th>FSC</th>
                  <th>VIN</th>
                  <th>PDI</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                {gridRows.map((r, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{r.model}</td>
                    <td>{r.variant}</td>
                    <td>{r.color}</td>
                    <td>{r.year}</td>
                    <td>{r.fsc}</td>
                    <td>{r.vin}</td>
                    <td>{r.pdi}</td>
                    <td>{r.location}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* BUTTONS */}
          <div className="va-btn-container">
            <button className="va-btn-save" onClick={handleSave}>
              Save
            </button>
            <button className="va-btn-exit" onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* 🔥 YOUR FULL STYLE SECTION STAYS EXACTLY AS IT IS BELOW */}

      {/* ----------------------------------------------------
            CSS EXACTLY LIKE INSURANCE MASTER / RATE MASTER
      ---------------------------------------------------- */}
      <style>
        {`
/* ================= PAGE ================= */

.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1400px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,.1);
}

/* ================= HEADERS ================= */

.header,
.header1 {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================= FORM GRID ================= */

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}



.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

/* ================= INPUTS ================= */

input,
select {
  height: 40px !important;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  background: #fff;
}

input[type="date"] {
  padding-right: 35px;
}

/* ================= react-select FIX ================= */

.rs__control {
  min-height: 40px !important;
  height: 40px !important;
  border-radius: 5px !important;
}

.rs__value-container {
  height: 40px !important;
  padding: 0 10px !important;
  display: flex;
  align-items: center;
}

.rs__indicator {
  padding: 6px !important;
}

.rs__menu-portal {
  z-index: 9999 !important;
}

/* ================= RADIO ================= */

.company-auth {
  max-width: 220px;
}

.radio-group {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 8px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}

.radio-group input {
  width: 16px;
  height: 16px;
}

/* ================= TABLE ================= */

.table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  font-size: 13px;
}

th,
td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

thead tr {
  background: #f8bcbc;
}

.grid-input {
  width: 100%;
  height: 32px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}

/* ================= BUTTONS ================= */

.va-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
  padding: 0 8px;
}

.va-btn-save,
.va-btn-exit {
  min-width: 120px;
  min-height: 44px;
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.2s;
  white-space: nowrap;
  box-sizing: border-box;
}

.va-btn-save {
  background: #4caf50;
  color: #fff;
}
.va-btn-save:hover { background: #43a047; }

.va-btn-exit {
  background: #ab2025;
  color: #fff;
}
.va-btn-exit:hover { background: #b02a37; }

.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.button-container button {
  min-width: 120px;
  min-height: 44px;
  padding: 12px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  border: none;
}

.btn-exit {
  background: #a20d0d;
  color: #fff;
  border: none;
}

.btn-edit {
  background: #2e20ab;
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
}

/* ================= RESPONSIVE ================= */

/* Tablet */
@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .va-btn-container {
    flex-direction: column;
    align-items: stretch;
    padding: 0 16px;
  }

  .va-btn-save,
  .va-btn-exit {
    width: 100%;
    text-align: center;
    font-size: 15px;
    padding: 12px 16px;
  }

  .button-container button {
    flex: 1;
    width: 100%;
  }
}

/* Extra small */
@media (max-width: 400px) {
  .va-btn-save,
  .va-btn-exit {
    font-size: 14px;
    padding: 11px 12px;
  }
}

`}
      </style>
    </Layout>
  );
};

export default VehicleAllocationDetailsDesign;
